import React, { useEffect, useState } from "react";
import { getAuth, sendEmailVerification } from "firebase/auth";

const EmailVerification = () => {
  const auth = getAuth();
  const user = auth.currentUser;
  const [verified, setVerified] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const checkStatus = async () => {
    setLoading(true);
    await user.reload(); // refresh the user data
    setVerified(user.emailVerified);
    setLoading(false);
  };

  const sendVerification = async () => {
    if (!user) {
      setMessage("No user is currently signed in.");
      return;
    }

    try {
      await sendEmailVerification(user);
      setMessage("Verification email sent! Check your inbox and click the link.");
    } catch (err) {
      console.error(err);
      setMessage("Error sending verification email.");
    }
  };

  useEffect(() => {
    if (user) setVerified(user.emailVerified);
  }, [user]);

  if (!user) return <p>No user signed in.</p>;

  return (
    <div style={{ padding: "1rem", border: "1px solid #ddd", borderRadius: "8px", marginTop: "1rem" }}>
      <h3>Email Verification</h3>

      {verified === null && <p>Checking verification status...</p>}

      {verified && <p style={{ color: "green" }}>✅ Your email is verified: {user.email}</p>}

      {!verified && (
        <>
          <p style={{ color: "red" }}>❌ Your email is not verified.</p>
          <button
            onClick={sendVerification}
            style={{
              background: "#2563eb",
              color: "#fff",
              padding: "8px 14px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              marginRight: "8px"
            }}
          >
            Send Verification Email
          </button>
          <button
            onClick={checkStatus}
            style={{
              background: "#10b981",
              color: "#fff",
              padding: "8px 14px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer"
            }}
          >
            Recheck
          </button>
          <p style={{ marginTop: "8px", color: "#555" }}>{message}</p>
        </>
      )}
    </div>
  );
};

export default EmailVerification;
